/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerApiService } from './customer-api.service';
import { ConfigService } from 'src/app/service/config.service';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class ReportApiService {
  private reportingUrl: string;

  constructor(
    private api: CustomerApiService,
    private http: HttpClient,
    private config: ConfigService,
    private tokenService: TokenService,
  ) {
    this.reportingUrl = this.config.appConfig.urlReportingServiceApi;
  }

  // COCKPIT REPORTS (Customer API)

  findReports(type?: string, size?: number): Observable<any> {
    const params: Record<string, string> = {};
    if (type) params['type'] = type;
    if (size) params['size'] = String(size);
    return this.api.get('/v2/cockpit_reports/find', params);
  }

  findReportById(id: string): Observable<any> {
    return this.api.get('/v2/cockpit_reports/findId/' + id);
  }

  storeReport(data: any): Observable<any> {
    return this.api.post('/v2/cockpit_reports/store', data);
  }

  changeReportLabel(data: any): Observable<any> {
    return this.api.post('/v1/cockpit_reports/set_label', data);
  }

  removeMultipleReports(idsArray: string[]): Observable<any> {
    return this.api.deleteWithBody('/v3/cockpit_reports', { ids: idsArray });
  }

  // REPORTING SERVICE (separate base URL)

  sendReport(company: string, type: string, date: string): Observable<any> {
    return this.http.post(`${this.reportingUrl}/api/company_report`, {
      date,
      company_id: company,
      report_type: type,
    });
  }

  sendReportPortfolio(
    portfolio: string,
    companies: string[],
    type: string,
    date: string,
  ): Observable<any> {
    return this.http.post(`${this.reportingUrl}/api/portfolio_report`, {
      date,
      portfolio_name: portfolio,
      company_ids: companies,
      report_type: type,
    });
  }

  getReportStatus(
    company: string,
    type: string,
    date: string,
  ): Observable<any> {
    return this.http.get(`${this.reportingUrl}/api/report_status`, {
      params: { company_id: company, report_type: type, date },
    });
  }

  getReportStatusPortfolio(
    portfolio: string,
    companies: string[],
    type: string,
    date: string,
  ): Observable<any> {
    return this.http.post(`${this.reportingUrl}/api/portfolio_report_status`, {
      portfolio_name: portfolio,
      company_ids: companies,
      report_type: type,
      date,
    });
  }

  sendQueryReport(
    searchQuery: string,
    queryName: string,
    reportType: string,
    date: string,
  ): Observable<any> {
    const decoded = this.tokenService.decodeToken();
    return this.http.post(`${this.reportingUrl}/api/query_report`, {
      report_type: reportType,
      date,
      search_query: searchQuery,
      query_name: queryName,
      recipients: [decoded?.email].filter(Boolean),
      format: 'pdf',
    });
  }

  // SLACK

  iSlack(data: any): Observable<any> {
    const domain = 'https://app.yukkalab.com';
    const hook =
      'https://hooks.slack.com/services/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';
    const message = {
      attachments: [
        {
          color: '#D00000',
          title:
            '<' +
            domain +
            '/admin/report?query=id:equal:' +
            data.id.id +
            '| Report - ' +
            data.report.report +
            '>',
          author_name:
            '<' +
            domain +
            '/admin/report?query=email:equal:' +
            data.report.email +
            '|' +
            data.report.email +
            '>',
          text: data.report.message,
        },
      ],
    };
    return this.http.post(hook, message, {
      headers: new HttpHeaders({ 'Content-Type': 'text/plain' }),
    });
  }
}
